import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" The following segments have not been recognised. If you process them as is then they won't be added to the correct segments. If you would like to map them to existing segments then "),
  /*#__PURE__*/_createElementVNode("strong", null, "select"),
  /*#__PURE__*/_createTextVNode(" an existing segment from the dropdown otherwise click "),
  /*#__PURE__*/_createElementVNode("strong", null, "delete"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_3 = { class: "tw-mt-8" }
const _hoisted_4 = { class: "tw-flex tw-justify-between tw-items-center tw-w-6/12 tw-gap-y-4" }
const _hoisted_5 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_6 = ["value"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

import { UseUpload } from "../../../../Pages/SegmentManagement/Uploads/Hooks/UseUpload";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  unknownSegmentNamesRef,
  knownSegmentNames,
  removeHeaderFromList,
  setCurrentToJsonRefString,
} = UseUpload();

const inputHandler = (e: Event, index: number) => {
  const val = (e.target as HTMLInputElement).value;
  setCurrentToJsonRefString(index, val);
};

return (_ctx: any,_cache: any) => {
  const _component_o_select = _resolveComponent("o-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(unknownSegmentNamesRef), (unknownSegments) => {
          return (_openBlock(), _createElementBlock("li", {
            key: unknownSegments.index,
            class: "tw-mb-4"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("strong", null, _toDisplayString(unknownSegments.segmentName), 1),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_o_select, {
                  placeholder: "Select a Segment",
                  onInput: (e) => inputHandler(e, unknownSegments.index)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(knownSegmentNames), (knownSegments) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: knownSegments.segment_name,
                        key: knownSegments.segment_name
                      }, _toDisplayString(knownSegments.segment_title), 9, _hoisted_6))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["onInput"]),
                _createElementVNode("span", {
                  class: "tw-underline tw-cursor-pointer",
                  onClick: _withModifiers(($event: any) => (_unref(removeHeaderFromList)(unknownSegments.index)), ["prevent"])
                }, "Delete", 8, _hoisted_7)
              ])
            ]),
            _hoisted_8
          ]))
        }), 128))
      ])
    ])
  ], 64))
}
}

})